export const ADD_TRUST = "fund/:memberId/trust/";
export const EDIT_TRUST = "/fund/:memberId/trust/:trustId/";
export const DELETE_TRUST = "/fund/:memberId/trust/:trustId/";
